var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 12C14.3402 12 16.2002 10.14 16.2002 7.79998C16.2002 5.45998 14.3402 3.59998 12.0002 3.59998C9.66017 3.59998 7.80017 5.45998 7.80017 7.79998C7.80017 10.14 9.66017 12 12.0002 12ZM12.0003 10.8C10.3203 10.8 9.00031 9.48 9.00031 7.8C9.00031 6.12 10.3203 4.8 12.0003 4.8C13.6803 4.8 15.0003 6.12 15.0003 7.8C15.0003 9.48 13.6803 10.8 12.0003 10.8ZM19.2003 21.6H4.80029V18C4.80029 15.36 6.96029 13.2 9.60029 13.2H14.4003C17.0403 13.2 19.2003 15.36 19.2003 18V21.6ZM18.0001 20.4V18C18.0001 16.02 16.3801 14.4 14.4001 14.4H9.60006C7.62006 14.4 6.00006 16.02 6.00006 18V20.4H18.0001Z",
    fill: "#1F3047"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.9a3f95d866825b6bd16127e8c40deb7a.svg";
export { ForwardRef as ReactComponent };